import React, { lazy } from "react";
import Loadable from "../../components/Loadable/Loadable";
import { ProtectedRoute } from "../../components";
import MyQualificationList from "./my-qualification/MyQualificationList";
import MyExperienceList from "./my-experience/MyExperienceList";
import MyApplicationList from "./my-applications/MyApplicationList";
import MyDocumentList from "./my-documents/MyDocumentList";

const Step1 = Loadable(lazy(() => import("./login/Step1")));
const Register = Loadable(lazy(() => import("./register/Register")));
const RegisterStepOne = Loadable(lazy(() => import("./register/RegisterStepOne")));
const ForgotPassword = Loadable(lazy(() => import("./forgot-password/ForgotPassword")));
const ResetPassword = Loadable(lazy(() => import("./reset-password/ResetPassword")));
const PaymentResponse = Loadable(lazy(() => import("./payments/PaymentResponse")));
const MyProfile = Loadable(lazy(() => import("./my-profile/MyProfile")));
const Home = Loadable(lazy(() => import("./Home/Home")));
const AadhaarCallback = Loadable(lazy(() => import("./aadhar-verification/AadhaarCallback")));

const sessionRoutes = [
    {
        path: "/session/signup",
        element: <Register />,
    },
    {
        path: "/session/signup/step1",
        element: <RegisterStepOne />,
    },
    {
        path: "/session/signin/step1",
        element: <Step1 />,
    },
    {
        path: "/session/forgot-password",
        element: <ForgotPassword />,
    },
    {
        path:"/reset-password",
        element: <ResetPassword />
    },
    {
        path: "/payment-response",
        element: <PaymentResponse />
    },
    // SECURITY: Protected routes - require authentication
    {
        path:"/my-profile",
        element: <ProtectedRoute><MyProfile /></ProtectedRoute>
    },
    {
        path:"/my-qualification",
        element: <ProtectedRoute><MyQualificationList /></ProtectedRoute>
    },
    {
        path:"/my-experience",
        element: <ProtectedRoute><MyExperienceList /></ProtectedRoute>
    },
    {
        path:"/my-applications",
        element: <ProtectedRoute><MyApplicationList /></ProtectedRoute>
    },
    {
        path:"/my-documents",
        element: <ProtectedRoute><Home /></ProtectedRoute>
    },
    {
        path: "/session/aadhaar-callback",
        element: <ProtectedRoute><AadhaarCallback /></ProtectedRoute>
    }
];

export default sessionRoutes;
